export default __webpack_public_path__ + "680b72b2766405ade197ef594807f9f1.svg";